import { NgModule } from '@angular/core';
import { CompareTraxxRoutingModule } from './compare-traxx-routing.module';

@NgModule({
  imports: [
    CompareTraxxRoutingModule
  ]
})
export class CompareTraxxModule { }
